import DataLoader from 'app/ui_v2/components/data-loader/DataLoader';
import { lazy, Suspense } from 'react';
import { Navigate, RouteObject } from 'react-router';

import InspectorProfileResolver from '../protected-routes/InspectorProfileResolver';
import { getInspectorPerformanceRoutes } from './inspectorPerformanceRoutes';

// Lazy load layouts and utilities
const InspectorProfileLayout = lazy(() => import('app/main/agency/inspector-profile/InspectorProfileLayout'));
const Error404Page = lazy(() => import('app/main/errors/Error404Page'));

// Lazy load page components
const InspectorProfileSections = lazy(
  () => import('../../../../main/agency/inspector-profile/profile-sections/InspectorProfileSections'),
);

const InspectorDisciplinesSections = lazy(
  () => import('../../../../main/agency/inspector-profile/qualifications-sections/InspectorDisciplinesSections'),
);

const InspectorEmployments = lazy(
  () => import('../../../../main/agency/inspector-profile/users-sections/employment/InspectorEmployment'),
);

const QaReportView = lazy(
  () => import('../../../../main/agency/profile/performance-sections/qa-report-view/QaReportView'),
);

export const inspectorProfileRoutes: RouteObject[] = [
  {
    path: '',
    element: (
      <InspectorProfileResolver>
        <InspectorProfileLayout />
      </InspectorProfileResolver>
    ),
    children: [
      {
        path: '',
        element: <Navigate to="main" />,
      },
      {
        path: 'main',
        element: (
          <Suspense fallback={<DataLoader />}>
            <InspectorProfileSections />
          </Suspense>
        ),
      },
      {
        path: 'disciplines',
        element: (
          <Suspense fallback={<DataLoader />}>
            <InspectorDisciplinesSections />
          </Suspense>
        ),
      },
      {
        path: 'metrics',
        children: getInspectorPerformanceRoutes([]),
      },
      {
        path: 'employment',
        element: (
          <Suspense fallback={<DataLoader />}>
            <InspectorEmployments />
          </Suspense>
        ),
      },

      {
        path: '*',
        element: <Error404Page />,
      },
      {
        path: ':any/*',
        element: <Error404Page />,
      },
    ],
  },
  {
    path: 'metrics/qa-report/:reportId',
    element: (
      <InspectorProfileResolver>
        <QaReportView view="inspector" />
      </InspectorProfileResolver>
    ),
  },
];

export const getInspectorProfileRoutes = (excludes: string[]): RouteObject[] => {
  const result =
    inspectorProfileRoutes[0].children?.filter((route: RouteObject) => {
      const path = route.path || '';
      return !excludes.some((exclude) => path.includes(exclude));
    }) ?? [];

  inspectorProfileRoutes[0].children = result;
  return inspectorProfileRoutes;
};
